/**
 * @module Utilities/Helpers
 * @desc Helpers helper funtions
 */

/**
 * Makes sure that your code is only triggered once per user input.
 * Search box suggestions, text-field auto-saves, and eliminating
 * double-button clicks are all use cases for debounce.
 */
export function debounce(func: any, timeout = 300) {
  let timer: ReturnType<typeof setTimeout>;

  return (...args: any) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, timeout);
  };
}
